import { hash } from '@ember/helper';
import { service } from '@ember/service';

import { trackedFunction } from 'reactiveweb/function';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsPersonComponent extends Component {
  // Services
  @service data;

  // Getter and setter
  get genderOptions() {
    return this.resolvedJobTypeOptions.value ?? [];
  }

  // Functions
  resolvedJobTypeOptions = trackedFunction(this, async () => {
    return await this.data.getCategories({ 'filter[type]': 'GENDER' });
  });

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            <fieldset.field
              @property='gender'
              @type='select-record'
              @options={{this.genderOptions}}
            />
            <fieldset.field @property='firstname' />
            <fieldset.field @property='lastname' />
            <fieldset.field @property='email' />
            <fieldset.field @property='fon' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='sections'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @filters={{hash type='POSITION'}}
              @property='positions'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
